var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.loading)?_c('div',{staticClass:"spinner container"},[_vm._m(0)]):_c('index',{attrs:{"loading":_vm.loading,"contents":_vm.contents.index,"publications":_vm.contents.publications}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered is-padding-8"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}),_vm._v(" Loading...\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d3bf660","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 211
// module chunks = 1